<template>
  <div>
    <v-toolbar class="elevation-1 rounded mt-2 white">
      <div class="d-flex" style="gap: 30px">
        <!-- Tora section -->
        <div v-if="hasTora" class="d-flex align-center">
          <span class="font-weight-bold secondary--text">
            <img
              width="25px"
              class="mr-1"
              style="vertical-align: middle"
              src="https://assets.trainplanet.com/wlabel/trainplanet/logos/favicon-32x32.png"
              alt="tora-logo" />Tora :
          </span>
          <div class="d-flex align-center ml-2">
            <span
              class="font-weight-black secondary--text"
              v-for="(id, index) in groupedToraBooking.groupedExternalIds"
              :key="id">
              {{ id }}
              <v-tooltip top :open-delay="1000" :close-delay="500" :open-on-hover="false">
                <template v-slot:activator="{ on }">
                  <v-icon color="mango-red" @click="copyToClipboard(id)" small v-on="on">mdi-content-copy</v-icon>
                </template>
                <span>Copied</span>
              </v-tooltip>
              <span v-if="index !== groupedToraBooking.groupedExternalIds.length - 1" class="black--text mx-1"> </span>
            </span>
          </div>
        </div>

        <!-- Linkonline section -->
        <div v-if="hasLinkonline" class="d-flex align-center">
          <span class="font-weight-bold secondary--text">
            <img width="20px" class="mr-1" src="@/assets/linkonline.svg" alt="linkonline-logo" />Linkonline :
          </span>
          <div class="d-flex align-center ml-2">
            <span
              class="font-weight-black secondary--text"
              v-for="(id, index) in groupedLinkonlineBooking.groupedExternalIds"
              :key="id">
              {{ id }}
              <v-tooltip top :open-delay="1000" :close-delay="500" :open-on-hover="false">
                <template v-slot:activator="{ on }">
                  <v-icon color="mango-red" @click="copyToClipboard(id)" small v-on="on">mdi-content-copy</v-icon>
                </template>
                <span>Copied</span>
              </v-tooltip>
              <span v-if="index !== groupedLinkonlineBooking.groupedExternalIds.length - 1" class="black--text mx-1">
              </span>
            </span>
          </div>
        </div>

        <!-- No external booking -->
        <span v-if="bookings.length < 1" class="grey--text"> No External Booking</span>
      </div>
      <v-spacer></v-spacer>

      <!-- Tenant Name & Logo -->
      <v-toolbar-title class="font-weight-bold black--text d-flex align-center">
        <img width="26px" class="mr-2" :src="tenantLogoUrl" alt="tenant-logo" />
        {{ tenantName }}
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
import { copyToClipboard, fixUrl } from "@/util/helpers";
import common from "@/mixins/common";

export default {
  name: "ExternalBookingSummary",
  props: {
    bookings: {
      type: Array,
      default: () => [],
    },
    tenantName: {
      type: String,
      required: true,
    },
  },
  mixins: [common],
  computed: {
    tenantLogoUrl() {
      return `https://assets.trainplanet.com/wlabel/${fixUrl(this.tenantName)}/logos/favicon-32x32.png`;
    },
    groupedBookings() {
      return this.groupedByExternalSystem(this.bookings);
    },
    groupedToraBooking() {
      return this.groupedBookings.find((booking) => booking.externalSystem === "tora") || { groupedExternalIds: [] };
    },
    groupedLinkonlineBooking() {
      return (
        this.groupedBookings.find((booking) => booking.externalSystem === "linkonline") || { groupedExternalIds: [] }
      );
    },
    hasTora() {
      return this.groupedBookings.some((booking) => booking.externalSystem === "tora");
    },
    hasLinkonline() {
      return this.groupedBookings.some((booking) => booking.externalSystem === "linkonline");
    },
  },
  methods: {
    copyToClipboard,
    fixUrl,
    groupedByExternalSystem(items = []) {
      return items.reduce((acc, curr) => {
        const externalSystem = acc.find((item) => curr.externalSystem === item.externalSystem);
        if (externalSystem) {
          externalSystem.groupedExternalIds.push(curr.externalBookingCode);
        } else {
          acc.push({ ...curr, groupedExternalIds: [curr.externalBookingCode] });
        }
        return acc;
      }, []);
    },
  },
};
</script>
